import { RoleRequestType } from '@/api/gamma-role-requests/types';
import type { RoleSummary } from '@/api/gamma-roles/types';

export type MemberRoleRequest = {
  type: typeof RoleRequestType.AssignRole | typeof RoleRequestType.RemoveRole;
  roleId: string;
};

export const roleRequestKey = ({ type, roleId }: MemberRoleRequest) => `${type}:${roleId}`;

type BuildRoleRequestsInput = {
  currentSystemKey: string;
  nextSystemKey: string;
  currentCustomIds: readonly string[];
  nextCustomIds: readonly string[];
  roles: readonly Pick<RoleSummary, 'id' | 'systemKey'>[];
};

export const buildRoleRequests = ({
  currentSystemKey,
  nextSystemKey,
  currentCustomIds,
  nextCustomIds,
  roles,
}: BuildRoleRequestsInput): MemberRoleRequest[] | null => {
  const isSystemRoleChanged = nextSystemKey !== currentSystemKey;
  const nextSystemRoleId = isSystemRoleChanged
    ? roles.find((role) => role.systemKey === nextSystemKey)?.id
    : undefined;
  if (isSystemRoleChanged && !nextSystemRoleId) return null;

  const systemRequests: MemberRoleRequest[] = nextSystemRoleId
    ? [{ type: RoleRequestType.AssignRole, roleId: nextSystemRoleId }]
    : [];

  return [
    ...systemRequests,
    ...nextCustomIds
      .filter((roleId) => !currentCustomIds.includes(roleId))
      .map((roleId) => ({ type: RoleRequestType.AssignRole, roleId })),
    ...currentCustomIds
      .filter((roleId) => !nextCustomIds.includes(roleId))
      .map((roleId) => ({ type: RoleRequestType.RemoveRole, roleId })),
  ];
};
